export default __webpack_public_path__ + "static/media/example-content1.144ff91d.jpg";